import { extractOppgaveIdFromPathname, extractOppgaveReturUrlFraPathname } from '@components/oppgave/utils/oppgave-url-utils';

export interface OppgaveFlowResult {
  oppgaveId: string | undefined;
  retururl: string;
  inOppgaveFlow: boolean;
}

/**
 * Simple oppgave flow detection based on URL.
 * When oppgaveId is in URL → user is in oppgave flow, hide buttons.
 * When oppgaveId is removed (after acceptance) → normal rules apply.
 */
export const getOppgaveFlowState = (): OppgaveFlowResult => {
  const oppgaveId = extractOppgaveIdFromPathname();
  const retururl = extractOppgaveReturUrlFraPathname();
  const inOppgaveFlow = !!oppgaveId;

  return { oppgaveId, retururl, inOppgaveFlow };
};
